import api from '../_api'
import { service as hyperCommonService } from '@/api/hyper-common'
import {
    FETCH_COST_PIVOT_REQUEST,
    FETCH_COST_PIVOT_SUCCESS,
    FETCH_COST_PIVOT_FAILED,
    CREATE_COST_PIVOT_FILTER_REQUEST,
    CREATE_COST_PIVOT_FILTER_SUCCESS,
    CREATE_COST_PIVOT_FILTER_FAILED,
    FETCH_COST_PIVOT_FILTER_REQUEST,
    FETCH_COST_PIVOT_FILTER_SUCCESS,
    FETCH_COST_PIVOT_FILTER_FAILED,
    DELETE_COST_PIVOT_FILTER_REQUEST,
    DELETE_COST_PIVOT_FILTER_SUCCESS,
    DELETE_COST_PIVOT_FILTER_FAILED,
    FETCH_COST_PIVOT_FILTER_NAMES_REQUEST,
    FETCH_COST_PIVOT_FILTER_NAMES_SUCCESS,
    FETCH_COST_PIVOT_FILTER_NAMES_FAILED,
    FETCH_USER_TAGS_REQUEST,
    FETCH_USER_TAGS_SUCCESS,
    FETCH_USER_TAGS_FAILED,
    FETCH_COST_PIVOT_DOWNLOAD_REQUEST,
    FETCH_COST_PIVOT_DOWNLOAD_SUCCESS,
    FETCH_COST_PIVOT_DOWNLOAD_FAILED,
    FETCH_COST_PIVOT_DOWNLOAD_STATUS_REQUEST,
    FETCH_COST_PIVOT_DOWNLOAD_STATUS_SUCCESS,
    FETCH_COST_PIVOT_DOWNLOAD_STATUS_FAILED,
    SET_DOWNLOAD_MODE,
    FETCH_COST_DOWNLOAD_REQUEST,
    FETCH_COST_DOWNLOAD_SUCCESS,
    FETCH_COST_DOWNLOAD_FAILED,
    FETCH_COST_DOWNLOAD_STATUS_REQUEST,
    FETCH_COST_DOWNLOAD_STATUS_SUCCESS,
    FETCH_COST_DOWNLOAD_STATUS_FAILED
} from './mutation-type'

const getCostPivot = async ({ commit, state, getters, rootGetters }, { qtype, projectIdx, groupIdx, indexes, compositSources, pivotFilter, minDate, maxDate, value }) => {
    commit(FETCH_COST_PIVOT_REQUEST, { initialize: !indexes.length })
    try {
        const { status, data, headers } =
            await api.fetchCostPivot({ qtype, projectIdx, groupIdx, indexes, compositSources, pivotFilter, minDate, maxDate, value }, rootGetters.requiredService)
        commit(FETCH_COST_PIVOT_SUCCESS, { status, data: data.data, headers })
        return data
    } catch (error) {
        commit(FETCH_COST_PIVOT_FAILED, error)
        throw error
    }
}

const createCostPivotFilter = async ({ commit, state, getters, rootGetters }, { userIdx, name, content }) => {
    commit(CREATE_COST_PIVOT_FILTER_REQUEST)
    try {
        const { status, data } = await hyperCommonService.createCostPivotFilter({ userIdx, name, content }, rootGetters.requiredService)
        commit(CREATE_COST_PIVOT_FILTER_SUCCESS, { status })
        return data
    } catch (error) {
        commit(CREATE_COST_PIVOT_FILTER_FAILED, error)
        throw error
    }
}

const getCostPivotFilter = async ({ commit, state, getters, rootGetters }, { costPivotFilterIdx }) => {
    commit(FETCH_COST_PIVOT_FILTER_REQUEST)
    try {
        const { status, data } = await hyperCommonService.fetchCostPivotFilter({ costPivotFilterIdx }, rootGetters.requiredService)
        commit(FETCH_COST_PIVOT_FILTER_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_COST_PIVOT_FILTER_FAILED, error)
        throw error
    }
}

const deleteCostPivotFilter = async ({ commit, state, getters, rootGetters }, { costPivotFilterIdx }) => {
    commit(DELETE_COST_PIVOT_FILTER_REQUEST)
    try {
        const { status, data } = await hyperCommonService.deleteCostPivotFilter({ costPivotFilterIdx }, rootGetters.requiredService)
        commit(DELETE_COST_PIVOT_FILTER_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(DELETE_COST_PIVOT_FILTER_FAILED, error)
        throw error
    }
}

const getCostPivotFilterNames = async ({ commit, state, getters, rootGetters }, { userIdx }) => {
    commit(FETCH_COST_PIVOT_FILTER_NAMES_REQUEST)
    try {
        const { status, data } = await hyperCommonService.fetchCostPivotFilterNames({ userIdx }, rootGetters.requiredService)
        commit(FETCH_COST_PIVOT_FILTER_NAMES_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_COST_PIVOT_FILTER_NAMES_FAILED, error)
        throw error
    }
}

const getUserTag = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_USER_TAGS_REQUEST)
    try {
        const { status, data } = await api.fetchUserTag(rootGetters.requiredService)
        commit(FETCH_USER_TAGS_SUCCESS, { status, data })
        return data
    } catch (error) {
        commit(FETCH_USER_TAGS_FAILED, error)
        throw error
    }
}

const getCostPivotDownload = async ({ commit, state, getters, rootGetters }, { dataToken, dType, qtype, projectIdx, groupIdx, indexes, compositSources, pivotFilter, minDate, maxDate, value }) => {
    commit(FETCH_COST_PIVOT_DOWNLOAD_REQUEST)
    try {
        const response = await api.fetchCostPivotDownload({ dType, qtype, projectIdx, groupIdx, indexes, compositSources, pivotFilter, minDate, maxDate, value }, rootGetters.requiredService, dataToken)
        commit(FETCH_COST_PIVOT_DOWNLOAD_SUCCESS, { data: response.data })
        return response.data
    } catch (error) {
        commit(FETCH_COST_PIVOT_DOWNLOAD_FAILED, error)
        throw error
    }
}
const getCostPivotDownloadStatus = async ({ commit, state, getters, rootGetters }, { dataToken }) => {
    commit(FETCH_COST_PIVOT_DOWNLOAD_STATUS_REQUEST)
    try {
        const response = await api.fetchCostPivotDownloadStatus(rootGetters.requiredService, dataToken)
        commit(FETCH_COST_PIVOT_DOWNLOAD_STATUS_SUCCESS, { data: response.data })
        return response.data
    } catch (error) {
        commit(FETCH_COST_PIVOT_DOWNLOAD_STATUS_FAILED, error)
        throw error
    }
}
const setDownloadMode = ({ commit }, value) => {
    commit(SET_DOWNLOAD_MODE, value)
}
const getCostDownload = async ({ commit, state, getters, rootGetters }, { qtype, projectIdx, groupIdx, indexes, compositSources, pivotFilter, minDate, maxDate, value }) => {
    commit(FETCH_COST_DOWNLOAD_REQUEST)
    try {
        const response = await api.fetchCostDownload({ qtype, projectIdx, groupIdx, indexes, compositSources, pivotFilter, minDate, maxDate, value }, rootGetters.requiredService)
        commit(FETCH_COST_DOWNLOAD_SUCCESS, { data: response.data })
        return response.data
    } catch (error) {
        commit(FETCH_COST_DOWNLOAD_FAILED, error)
        throw error
    }
}
const getCostDownloadStatus = async ({ commit, state, getters, rootGetters }, { dataToken }) => {
    commit(FETCH_COST_DOWNLOAD_STATUS_REQUEST)
    try {
        const response = await api.fetchCostDownloadStatus(rootGetters.requiredService, dataToken)
        commit(FETCH_COST_DOWNLOAD_STATUS_SUCCESS, { data: response.data })
        return response.data
    } catch (error) {
        commit(FETCH_COST_DOWNLOAD_STATUS_FAILED, error)
        throw error
    }
}
const getCostDownloadPeriod = async ({ commit, state, getters, rootGetters }, { qtype, projectIdx, groupIdx }) => {
    try {
        const response = await api.fetchCostDownloadPeriod({ qtype, projectIdx, groupIdx }, rootGetters.requiredService)

        // API 응답은 response.data가 직접 period 데이터
        // { "minDate": "2022-01", "maxDate": "2025-04", "sizeOfData": null, "indexes": [...] }
        if (response && response.data) {
            // summary 구조로 감싸서 반환
            const result = {
                summary: response.data,
                status: response.status || 200
            }
            return result
        }
        return { summary: null, status: response.status }
    } catch (error) {
        console.error('[Action] getCostDownloadPeriod error:', error)
        throw error
    }
}
export default {
    getCostPivot,
    createCostPivotFilter,
    getCostPivotFilter,
    deleteCostPivotFilter,
    getCostPivotFilterNames,
    getUserTag,
    getCostPivotDownload,
    getCostPivotDownloadStatus,
    setDownloadMode,
    getCostDownload,
    getCostDownloadStatus,
    getCostDownloadPeriod
}
